import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  brandGroupCreate,
  brandGroupCreateVariables
} from "./types/brandGroupCreate";
import {
  brandGroupDelete,
  brandGroupDeleteVariables
} from "./types/brandGroupDelete";
import {
  BrandGroupUpdate,
  BrandGroupUpdateVariables
} from "./types/brandGroupUpdate";

const brandGroupCreateMutation = gql`
  mutation brandGroupCreate($input: BrandGroupCreateInput!) {
    brandGroupCreate(input: $input) {
      brandErrors {
        field
        message
        code
      }
      brandGroup {
        name
        code
        vertical
        tags {
          name
          id
        }
        classification
        dynamicLink
        image {
          alt
          url
        }
        isSmacAffiliate
      }
    }
  }
`;
export const useBrandGroupCreate = makeMutation<
  brandGroupCreate,
  brandGroupCreateVariables
>(brandGroupCreateMutation);

export const brandGroupUpdateMutation = gql`
  mutation BrandGroupUpdate($id: ID!, $input: BrandGroupUpdateInput!) {
    brandGroupUpdate(id: $id, input: $input) {
      brandErrors {
        field
        message
        code
      }
      brandGroup {
        name
        code
        vertical
        tags {
          name
          id
        }
        classification
        dynamicLink
        image {
          alt
          url
        }
        isSmacAffiliate
      }
    }
  }
`;
export const useBrandGroupUpdate = makeMutation<
  BrandGroupUpdate,
  BrandGroupUpdateVariables
>(brandGroupUpdateMutation);

export const brandGroupDeleteMutation = gql`
  mutation brandGroupDelete($id: ID!) {
    brandGroupDelete(id: $id) {
      brandErrors {
        field
        message
        code
      }
    }
  }
`;

export const useBrandGroupDelete = makeMutation<
  brandGroupDelete,
  brandGroupDeleteVariables
>(brandGroupDeleteMutation);
